import { createFileRoute } from "@tanstack/react-router";
import AdminManufacturers from "@/pages/admin/AdminManufacturers";

export const Route = createFileRoute("/_adminLayout/admin/parts/manufacturers/")({
  component: AdminManufacturers,
});